module.exports = __webpack_public_path__ + "img/lightbox-avg.21daf650.svg";